import { FC } from 'react';
import { IconProps } from '../types';

export const LogoIcon: FC<IconProps> = ({ height = '22', width = '180', className }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 180 22'
    fill='none'
    className={className}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M166.652 12.0313H172.168C176.855 12.0313 176.855 5.1742 172.168 5.1742H166.652V12.0313ZM172.136 15.3964H166.62V21.079H162.922V1.68214C165.983 1.68214 169.044 1.65039 172.104 1.65039C181.67 1.68214 181.702 15.3964 172.136 15.3964Z'
      fill='#373185'
    />
    <path
      d='M157.311 1.74609V12.8572C157.311 18.5715 153.771 21.5239 148.861 21.5239C144.174 21.5239 140.221 18.6985 140.221 12.8572V1.74609H143.887V12.8572C143.887 16.3493 145.896 18.2223 148.925 18.2223C151.954 18.2223 153.676 16.1905 153.676 12.8572V1.74609H157.311Z'
      fill='#373185'
    />
    <path
      d='M122.939 10.6667H134.354V12.0001H122.939V19.6509H135.215V21.0794H121.473V1.68262H134.896V3.07944H122.939V10.6667Z'
      fill='#373185'
    />
    <path
      d='M101.004 3.11119V19.6509H106.105C111.908 19.6509 114.555 15.3334 114.491 11.1747C114.427 7.11119 111.749 3.11119 106.105 3.11119H101.004ZM115.989 11.1747C116.085 16.1271 112.928 21.0794 106.105 21.0794C103.905 21.0794 101.705 21.0794 99.5371 21.0794V1.68262C101.737 1.68262 103.937 1.68262 106.105 1.68262C112.705 1.71436 115.862 6.41278 115.989 11.1747Z'
      fill='#373185'
    />
    <path d='M93.287 1.68262H91.8203V21.0794H93.287V1.68262Z' fill='#373185' />
    <path
      d='M73.1685 12.3493H80.0554C83.4351 12.3493 84.9337 10.4445 84.9975 7.71436C85.0293 5.4604 83.467 3.07944 80.2467 3.07944H73.1685V12.3493ZM87.1975 21.0794H85.2206L78.4931 13.7461H73.2004V21.0794H71.6699V1.68262C74.5395 1.68262 77.3772 1.68262 80.2467 1.68262C84.4873 1.68262 86.6235 4.69849 86.6554 7.71436C86.6873 10.8572 84.583 13.6509 80.3424 13.6509L87.1975 21.0794Z'
      fill='#373185'
    />
    <path d='M58.1825 3.07943H51.168V1.74609H66.7274V3.07943H59.681V21.0794H58.1825V3.07943Z' fill='#373185' />
    <path
      d='M45.589 5.46046C44.1861 3.20649 41.8904 2.85728 39.6904 2.82554C37.4266 2.82554 33.7918 3.65093 33.7918 6.76205C33.7918 9.23824 36.4701 9.80966 39.7542 10.4446C43.5165 11.1747 47.4063 11.8097 47.4063 16.0001C47.3745 20.3811 42.9745 21.4287 39.6904 21.4287C36.6614 21.4287 33.2179 20.1906 31.6875 17.2065L33.0266 16.5398C34.2382 18.9208 37.2991 20.0636 39.6904 20.0636C42.0817 20.0636 45.9078 19.397 45.9078 15.9684C45.9397 13.0478 42.7194 12.4446 39.4991 11.8097C35.96 11.1113 32.2933 10.4128 32.2933 6.82554C32.2295 2.7303 36.502 1.42871 39.6904 1.42871C42.4962 1.42871 44.8875 1.87316 46.8324 4.7303L45.589 5.46046Z'
      fill='#373185'
    />
    <path
      d='M21.2608 18.9523C21.2608 20.3491 20.0492 21.4919 18.5825 21.4919H18.4869C16.9883 21.4919 15.8086 20.3491 15.8086 18.9523V3.0475C15.8086 1.65067 17.0202 0.507812 18.4869 0.507812H18.5825C20.0811 0.507812 21.2608 1.65067 21.2608 3.0475V18.9523Z'
      fill='#4FB57F'
    />
    <path
      d='M13.5766 19.0155C13.5766 20.3806 12.3969 21.4917 10.9621 21.4917H10.8664C9.39978 21.4917 8.25195 20.3806 8.25195 19.0155V8.03137C8.25195 6.6663 9.43166 5.52344 10.8664 5.52344H10.9621C12.4288 5.52344 13.5766 6.6663 13.5766 8.03137V19.0155Z'
      fill='#F2AD4C'
    />
    <path
      d='M5.98865 18.6667C5.98865 20.2223 4.77705 21.4921 3.2785 21.4921C1.77995 21.4921 0.568359 20.2223 0.568359 18.6667V14.508C0.568359 12.9525 1.77995 11.6826 3.2785 11.6826C4.77705 11.6826 5.98865 12.9525 5.98865 14.508V18.6667Z'
      fill='#ED5E5A'
    />
  </svg>
);
